import { defineComponent, ref } from "vue";
import SmeLayout from "../../layouts/SmeLayout";
import SmePhoneForm from "../../components/SmePhoneForm";

export default defineComponent({
    components: {
        SmeLayout,
        SmePhoneForm,
    },

    template: `
        <SmeLayout class="StepSmeOtherTariff">
            <div class="SmeSupportFormBox contentbox contentbox--white">
                <h1 class="title-2">Gratulujemy! Twoja firma już cieszy się Respectem!</h1>

                <p class="SmeSupportFormBox__text">Na podstawie numeru NIP widzimy, że Twoja firma ma aktywną umowę z Respect Energy. Wprowadź swój numer telefonu, a nasz Doradca skontaktuje się z Tobą.</p>

                <SmePhoneForm type="nip.found" />
            </div>
        </SmeLayout>
    `,

    emits: [
        'renew'
    ],

    props: {
    },

    setup(props, ctx) {
    },
});
